/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import { useGlobalTheme } from '@atlaskit/theme/components';
import { h600 } from '@atlaskit/theme/typography';
const formSectionDescriptionStyles = css({
  marginTop: "var(--ds-space-100, 8px)"
});
const formSectionTitleStyles = css({
  marginTop: 0,
  marginRight: "var(--ds-space-400, 32px)",
  lineHeight: "var(--ds-space-400, 32px)",
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  // Use "clip" overflow to allow ellipses on x-axis without clipping descenders
  '@supports not (overflow-x: clip)': {
    overflow: 'hidden'
  },
  '@supports (overflow-x: clip)': {
    overflowX: 'clip'
  }
});
const formSectionWrapperStyles = css({
  marginTop: "var(--ds-space-300, 24px)"
});

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const lightH600Styles = css(h600({
  theme: {
    mode: 'light'
  }
}));
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const darkH600Styles = css(h600({
  theme: {
    mode: 'dark'
  }
}));
const FormSectionWrapper = ({
  children
}) => {
  return jsx("div", {
    css: formSectionWrapperStyles
  }, children);
};
const FormSectionTitle = ({
  children
}) => {
  const {
    mode
  } = useGlobalTheme();
  return jsx("h3", {
    css: [formSectionTitleStyles, mode === 'light' ? lightH600Styles : darkH600Styles]
  }, children);
};
const FormSectionDescription = ({
  children
}) => {
  return jsx("div", {
    css: formSectionDescriptionStyles
  }, children);
};

/**
 * __Form section__
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 */
const FormSection = ({
  children,
  description,
  title
}) => {
  return jsx(FormSectionWrapper, null, title && jsx(FormSectionTitle, null, title), description && jsx(FormSectionDescription, null, description), children);
};
export default FormSection;